export var AllowedKeys;
(function (AllowedKeys) {
    AllowedKeys["Backspace"] = "Backspace";
    AllowedKeys["Delete"] = "Delete";
    AllowedKeys["ArrowUp"] = "ArrowUp";
    AllowedKeys["ArrowDown"] = "ArrowDown";
    AllowedKeys["ArrowLeft"] = "ArrowLeft";
    AllowedKeys["ArrowRight"] = "ArrowRight";
})(AllowedKeys || (AllowedKeys = {}));
//# sourceMappingURL=typings.js.map